/** @jsxImportSource react */
import EntityTile from '@react/card';
import { useEvents } from '@react/services/events';
import { arrayOf, bool, func, object, string } from 'proptypes';
import { useEffect } from 'react';

/**
 * @param {{
 *   communities: any[],
 *   city?: string,
 *   state?: string,
 *   onCommunityClick?: (...args: any[]) => void,
 *   eventProps?: Record<string, any>,
 *   canFavourite?: boolean
 * }} props
 */
const SimilarCommunities = ({
  communities,
  city,
  state,
  onCommunityClick = () => {},
  eventProps = {},
  canFavourite = false,
}) => {
  const { sendCommunityListViewedEvent } = useEvents();

  useEffect(() => {
    sendCommunityListViewedEvent(
      communities,
      city,
      state,
      'similar communities'
    );
  }, []);

  return (
    <>
      {communities.map((community) => (
        <EntityTile key={community.id} entity={community} intent='vertical' />
      ))}
    </>
  );
};

SimilarCommunities.propTypes = {
  communities: arrayOf(object),
  onCommunityClick: func,
  eventProps: object,
  communityStyle: object,
  canFavourite: bool,
  city: string,
  state: string,
};

export default SimilarCommunities;
